export const GLOBAL_SEARCH_SCOPES = [
  'routes',
  'help',
  'contacts',
  'projects',
  'bookings',
  'emails',
  'invoices',
  'packages',
  'feedback',
] as const;

export type GlobalSearchScope = (typeof GLOBAL_SEARCH_SCOPES)[number];

export const GLOBAL_SEARCH_SCOPE_LABELS: Record<GlobalSearchScope, string> = {
  routes: 'Pages',
  help: 'Help',
  contacts: 'Contacts',
  projects: 'Projects',
  bookings: 'Bookings',
  emails: 'Messages',
  invoices: 'Invoices',
  packages: 'Packages',
  feedback: 'Support',
};

const scopeSet = new Set<string>(GLOBAL_SEARCH_SCOPES);

export const isGlobalSearchScope = (value: string): value is GlobalSearchScope => {
  return scopeSet.has(value);
};

export const parseScopeQuery = (
  rawQuery: string,
  fallbackScope: GlobalSearchScope | null = null
) => {
  const trimmedQuery = rawQuery.trim();
  const scopeMatch = trimmedQuery.match(/^in:([a-z,]+)\s*(.*)$/i);
  const matchedScopes = scopeMatch?.[1]
    ?.split(',')
    .map(scope => scope.trim().toLowerCase())
    .filter(isGlobalSearchScope);
  let scopes: GlobalSearchScope[] = [];

  if (matchedScopes && matchedScopes.length > 0) {
    scopes = matchedScopes;
  } else if (fallbackScope) {
    scopes = [fallbackScope];
  }

  return {
    query: (scopeMatch?.[2] ?? trimmedQuery).trim(),
    scopes,
  };
};
